$(document).ready(($) => {
  const unsub = $('#id_subscription_setting_1');
  const sub = $('#id_subscription_setting_0');
  const $checkboxes = $('input:checkbox');
  const $group = $('.opt-in-group');

  if (window.subscribed == '[]') {
    $(unsub).prop('checked', true);
  } else {
    $(sub).prop('checked', true);
    $.each($checkboxes, function () {
      if ($(this).prop('checked')) {
        $(this).closest('.opt-in-group').addClass('selected');
      }
    });
  }

  $(unsub).on('change', () => {
    unsubscribe();
  });
  $(sub).on('change', () => {
    $(unsub).prop('checked', false);
    $(sub).trigger('click');
  });

  $('.opt-in-group, input:checkbox').on('click', clickCheckbox);

  $('form').on('submit', () => {
    const checked_checkboxes = getNumberOfCheckedCheckboxes();
    if (sub.prop('checked') && checked_checkboxes === 0) {
      $('.error-message').show();
      return false;
    }
  });

  function getNumberOfCheckedCheckboxes() {
    let checked = 0;
    $checkboxes.map((i, box) => {
      if ($(box).prop('checked')) {
        checked += 1;
      }
    });
    return checked;
  }

  function unsubscribe() {
    $('.error-message').hide();
    $checkboxes.prop('checked', false);
    $group.removeClass('selected');
    $(sub).prop('checked', false);
    $(unsub).prop('checked', true);
  }

  function clickCheckbox(e) {
    const clicked = $(this).closest('.opt-in-group');
    $('.error-message').hide();
    if (clicked.hasClass('selected')) {
      $(clicked).removeClass('selected');
      clicked.find('input:checkbox').prop('checked', false);
    } else {
      $(clicked).addClass('selected');
      clicked.find('input:checkbox').prop('checked', true);
    }

    $(unsub).prop('checked', false);
    $(sub).prop('checked', true);

    const checked_checkboxes = getNumberOfCheckedCheckboxes();
    if (checked_checkboxes === 0) {
      unsubscribe();
    }
  }
});
